import React, { useRef, useEffect } from 'react';
import { transformInput } from "./transformInput";

function PhoneInput(props) {
    let { value, onChange, ...rest } = props; 
    const initialRender = useRef(true);
    let inputRef = useRef(null);

    const onInputChange = (e) => {
        e.target.value = e.target.value.replace(/[^0-9]/g, "");

        if (value != e.target.value) {
            onChange(e);
        }
    };

    let mask = "(   )   -";
    let transformed = transformInput(mask, value);

    useEffect(() => {
        if (initialRender.current) {
            initialRender.current = false;
        }
        else {
            if (inputRef.current) {
                inputRef.current.selectionStart = inputRef.current.selectionEnd = transformed.lastIndex + 1;
            }
        }        
    }, [value]);

    return (
        <input
            {...rest}
            ref={inputRef}
            value={transformed.maskedInput}
            onChange={onInputChange}
            maxLength="13"
        />
    );

}

export default PhoneInput;